import { shallowEqual } from 'react-redux';

import { getInvalidFields } from '../../components/registering/utils/validation';
import useSelector from '../../hooks/useSelector';
import { RegistrationStep } from '../../utils/navigation';

export const StepperId = 'stepper';

export const useErrors = (step: RegistrationStep) => {
  const errors = useSelector((state) => getInvalidFields(state, step), shallowEqual);

  return { errors };
};
